import React from "react";
import '../../styles/InputText.css';

const InputText = (props) => {
    return (
        <div className="text-box-container" style={{width:props.width}}>
            <div className="text-label">{props.label}</div>
            <input className="text-box" type="text" onChange={(e)=>{props.onChange(e.target.value)}} value={props.value}/>
        </div>
    )
}
export default InputText;